export default __webpack_public_path__ + "static/media/qrcode.57300e7a.svg";